  /*============Footer Controller
    ================================*/
  angular
    .module('vppApp')
    .controller('footerController', footerController);

  footerController.$inject = ['$scope', '$rootScope', 'footerFactory', '$stateParams', 'vppConfig', '$state', 'SetLiveSwapService', 'VarientService'];

  function footerController($scope, $rootScope, footerFactory, $stateParams, vppConfig, $state, SetLiveSwapService, VarientService) {
    var liveswap = SetLiveSwapService.getLSBrandName();
    $scope.copyRight = vppConfig.reusableValues.currentYear;
    $scope.siteName = vppConfig.siteNames[vppConfig.folderPath];
    $scope.disclaimerLead;
    $scope.disclaimerHome = vppConfig.indexDisclaimer;
    $scope.showAdditionalFeeInfo = false;
    $scope.varient = VarientService.getVarientName();

    // for difference in BuyPower Card types listed in the disclaimer
    if (domainAbbr === 'cgp' ||
      domainAbbr === 'mpp' ||
      domainAbbr === 'gmed' ||
      domainAbbr === 'frd') {
      $scope.BPCardTypes = vppConfig.disclaimerVariation.long;
    } else {
      $scope.BPCardTypes = vppConfig.disclaimerVariation.short;
    }

    //Site specific disclaimers
    var disclaimerChange = function() {
      switch (domainAbbr) {
        case 'gmed':
          $scope.disclaimerLead = vppConfig.educatorFootDisclaimer;
          break;
        case "mpp":
          $scope.disclaimerLead = vppConfig.militaryFootDisclaimer;
          break;
        case "cgp":
          $scope.disclaimerLead = vppConfig.collegeFootDisclaimer;
          break;
        case "ded":
          $scope.disclaimerLead = vppConfig.dealerFootDisclaimer;
          break;
        case "emp":
          $scope.disclaimerLead = vppConfig.familyFirstFootDisclaimer;
          break;
        case "sup":
          $scope.disclaimerLead = vppConfig.supplierFootDisclaimer;
          break;
        case "frd":
          $scope.disclaimerLead = vppConfig.firstresponderFootDisclaimer;
          break;
        default:
          $scope.disclaimerLead = null;
      }
    }

    //page specific disclaimers
    var disclaimerPage = function() {
      var setState = $state.current.name;
      switch (setState) {
        case 'index':
          $scope.disclaimerPageSpec = vppConfig.indexDisclaimer;
          break;
        case 'shopping-tools.build':
          $scope.disclaimerPageSpec = vppConfig.vehiclesDisclaimer;
          break;
        case 'offers':
          $scope.disclaimerPageSpec = vppConfig.offersDisclaimer;
          break;
        default:
          $scope.disclaimerPageSpec = null;
      }
    }

    // There's an specific sentence about Fee info which it doesn't have to show in Dealer(ded):
    if (domainAbbr === 'ded') {
      $scope.showAdditionalFeeInfo = true;
    }

    $scope.$on("$stateChangeSuccess", function(event, toState, toParams, fromState, fromParams) {
      //call cahnges to the disclaimers on state change
      disclaimerChange();
      disclaimerPage();
    });
    //call cahnges to the disclaimers on page load
    disclaimerChange();
    disclaimerPage();

    footerFactory().then(function(response) {
      var columns = response.data.footerNav.columns;
      $scope.columns = []

      for (var i = 0; i < columns.length; i++) {
        var column = columns[i]
        var liveswapHide = columns[i].liveswap;
        if (liveswap && !liveswapHide) {
          $scope.columns.push(column);
        } else if (!liveswap) {
          $scope.columns.push(column);
        }
      }

    });
  };
